module.exports = __webpack_public_path__ + "static/img/item01.6260f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item01.png
// module id = U9wE
// module chunks = 0